<template>
    <div>
        <!-- header in home page  -->
        <div class="flex campaign-header">
            <div class="tab-group">
                <div class="flex tabs">
                    <p :class="{active: activeTab === 'allcampaign'}" @click="handleAllCampaignClick">
                        All campaigns
                        <span v-if="activeTab === 'allcampaign'">({{ totalCampaignCount }})</span>
                    </p>
                    <p :class="{active: activeTab === 'activecampaign'}" @click="handleActiveCampaignClick">
                        Active campaigns
                        <span v-if="activeTab === 'activecampaign'">({{ totalCampaignCount }})</span>
                    </p>
                </div>

                <!-- sort campaigns dropdown  -->
                <v-menu :close-on-content-click="true" offset-y offset-x right>
                    <template v-slot:activator="{on, attrs}">
                        <p class="sort-btn" v-bind="attrs" v-on="on">
                            <span v-if="selectedSortType != ''" class="datecon">0</span>
                            Sort Campaigns <v-icon> mdi-chevron-down </v-icon>
                        </p>
                    </template>
                    <div class="filter-con">
                        <div class="button-con" v-for="(item, index) in sortParams" :key="index">
                            <button :class="{active: selectedSortType === item.query_name}" @click="handleSortButtonClicked(item.query_name)">
                                {{ item.display_name }}
                            </button>
                        </div>
                    </div>
                </v-menu>
            </div>

            <!-- search and info button  -->
            <div class="flex" style="justify-content: space-between">
                <v-icon @click="InfoOverlay = true" style="color: #1d8d56; margin-right: 5px" size="30">mdi-information-outline</v-icon>
                <div class="search-con flex">
                    <!-- to select campaign objective  -->
                    <v-select
                        :items="campaignObjective"
                        v-model="searchField"
                        class="campaignType"
                        v-if="filterType.query_name === 'campaign_objective'"
                        background-color="white"
                        color="#1D8D56"
                        filled
                        placeholder="Filled style"
                        :append-icon="icon"
                        @click:append="clearsearchfield"
                        @keyup.enter="searchCampaign"
                    ></v-select>
                    <v-text-field
                        v-else
                        v-model="searchField"
                        placeholder="Search campaign"
                        solo
                        class="serarchbtn"
                        background-color="white"
                        color="#1D8D56"
                        :append-icon="icon"
                        @click:append="clearsearchfield"
                        @keyup.enter="searchCampaign"
                    ></v-text-field>

                    <v-select
                        class="filterType"
                        :items="queryParmas"
                        item-text="display_name"
                        item-value="query_name"
                        placeholder="Filter Type"
                        filled
                        background-color="white"
                        color="#1D8D56"
                        return-object
                        v-model="filterType"
                    ></v-select>
                </div>

                <v-btn class="infobtn" large elevation="0" color="#ebf5f0" @click="searchCampaign"> Search </v-btn>
                <v-btn @click="createCampaignOverlay = true" large class="createbtn" elevation="0" color="#1D8D56"> + Create New </v-btn>
            </div>
        </div>

        <!-- loader, no data and campaign list section  -->
        <div v-if="loading" class="loader">
            <v-progress-circular :size="100" :width="8" color="#6FB793" indeterminate></v-progress-circular>
        </div>
        <div class="nodata-msg" v-else-if="!loading && totalCampaignCount === 0">
            <p>No data present.</p>
        </div>
        <div v-else class="business-card-con">
            <campaign-card :campaignList="campaignList" @reloadApi="reloadApi" />
        </div>

        <!-- create campaign part  -->
        <div v-if="createCampaignOverlay">
            <create-campaign
                :isEditCampaign="false"
                :opacity="0.8"
                :createCampaignOverlay="createCampaignOverlay"
                @closeCreateCampaignOverlay="closeCreateCampaignOverlay"
                @reloadApi="reloadApi"
            />
        </div>

        <!-- info card overlay  -->
        <info-card :InfoOverlay="InfoOverlay" @closeInfoCard="closeInfoCard" />

        <!-- for pagination  -->
        <div v-show="!loading && campaignList.length !== 0" class="pagination-con">
            <pagination :total="totalCampaignCount" ref="paginationRef" :perPage="10" @changePage="getCampaignList()" />
        </div>
    </div>
</template>

<script>
import API_URL from "../../../helpers/apiUrls";
import accessToken from "../../../helpers/accessToken";

// import components
import campaignCard from "./Components/campaign-card.vue";
import createCampaign from "./Components/create-campaign.vue";
import editPosts from "./Components/edit-posts.vue";
import productList from "./Components/product-list.vue";
import createAdvertisement from "./Components/create-advertisement.vue";
import successPage from "./Components/success-page.vue";
import leadForm from "./Components/lead-form.vue";
import pagination from "../../MainDashboard/Common/pagination.vue";
import info from "./Components/info.vue";
import leadFormList from "./Components/form-list.vue";

export default {
    name: "homepage",
    data() {
        return {
            createCampaignOverlay: false,
            campaignList: [],
            queryParmas: [],
            totalCampaignCount: 0,
            loading: false,
            searchField: "",
            params: "",
            icon: "",
            InfoOverlay: false,
            filterType: {display_name: "Campaign Name", query_name: "campaign_name"},
            selectedSortType: "",
            activeTab: "allcampaign",
            sortParams: [],
            campaignObjective : [],

            // api params
            sortByParam : "",
            isActiveParam : "",
            searchParam : "",
        };
    },
    components: {
        "campaign-card": campaignCard,
        "create-campaign": createCampaign,
        "create-advertisement": createAdvertisement,
        "success-page": successPage,
        "product-list": productList,
        "lead-form": leadForm,
        "edit-posts": editPosts,
        "info-card": info,
        pagination: pagination,
        "leadForm-List": leadFormList,
    },
    mounted() {
        this.getCampaignList();
    },
    watch: {
        // display cross icon if someone types in search field
        searchField: function () {
            console.log("searchField", this.searchField);

            if (this.searchField.length === 0) {
                this.icon = "";
            }
            if (this.searchField.length !== 0) {
                this.icon = "mdi-close";
            }
        },

    },

    methods: {
        handleAllCampaignClick() {
            this.activeTab = "allcampaign";
            this.$refs.paginationRef.page = 1;

            this.isActiveParam = "";
            this.getCampaignList();
        },
        handleActiveCampaignClick() {
            this.activeTab = "activecampaign";
            this.$refs.paginationRef.page = 1;

            this.isActiveParam = false;
            this.getCampaignList();
        },

        // apply sorting on campaign list
        handleSortButtonClicked(query_name) {
            this.selectedSortType = query_name;
            this.sortByParam = this.selectedSortType;

            this.getCampaignList();
        },

        // search campaigns with params (if exists)
        searchCampaign() {
            this.$refs.paginationRef.page = 1;

            this.searchParam = this.filterType.query_name;
            this.getCampaignList();
        },


        clearsearchfield() {
            this.searchField = "";
            this.searchParam = "";
            this.getCampaignList();
        },
        closeInfoCard() {
            this.InfoOverlay = false;
        },
        reloadApi() {
            this.createCampaignOverlay = false;
            this.$refs.paginationRef.page = 1;
            this.getCampaignList();
        },

        closeCreateCampaignOverlay() {
            this.createCampaignOverlay = false;
        },

        // get all the campaign list
        getCampaignList() {
            this.loading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.loading = false;
                    this.campaignList = response.data.data;
                    this.totalCampaignCount = response.data.count;
                    this.queryParmas = response.data.query_params;
                    this.sortParams = response.data.sort_params;
                    this.campaignObjective = response.data.query_params[5].options;
                   
                }
            };
            const errorHandler = (response) => {
                this.showToast("Something went wrong internally!", "error", 10000);
            };
            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            let apiParam = `?page=${this.$refs.paginationRef.page}&data_per_page=${10}${this.params}`
            if(this.isActiveParam !== ''){
                apiParam = apiParam + `&is_paused=${false}`;
            }
            if(this.sortByParam != ''){
                apiParam = apiParam + `&sort_by=${this.sortByParam}`;
            }
            if(this.searchParam != ''){
                apiParam = apiParam + `&query_text=${this.searchField}&query_param=${this.searchParam}`
            }

            console.log("PARAM-->", apiParam);
            this.requestGET(
                `${API_URL.getCampaignList}${apiParam}`,
                {},
                headers,
                successHandler,
                errorHandler
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.campaign-header {
    width: 100%;
    margin-bottom: 20px;
    justify-content: space-between;
}
.tab-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
        font-weight: 500;
        margin-bottom: 0px;
    }
}
.tabs {
    p {
        color: #3b3b3b;
        cursor: pointer;
        margin-right: 20px;
        &.active {
            color: #1d8d56;
        }
    }
}
.active-tab {
    color: #1d8d56 !important;
}
.v-tabs {
    display: flex;
    justify-content: space-between;
    width: 30%;
}
.v-tab {
    text-transform: capitalize !important;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
}
.filter-con {
    padding: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    button {
        padding: 6px 8px;
        border-radius: 4px;
        text-align: left;
        width: 100%;

        &:hover {
            background-color: #ebf5f0;
        }

        &.active {
            background-color: #1d8d56;
            color: #ffffff;
        }
    }
}
.button-con {
    width: 100%;
    margin-bottom: 10px;
}

.sort-btn {
    margin-right: 10px;
    display: flex;
    align-items: center;


    color: #3b3b3b;
    

    &:hover {
        color: #1d8d56 !important;
        .v-icon {
            color: #1d8d56 !important;
        }
    }
}
.createbtn {
    color: #fff !important;
    height: 44px !important;
    border-radius: 8px;
    cursor: pointer;
    margin-left: 5px;
    text-transform: capitalize !important;
    font-size: 14px !important;
    font-weight: 500;
}
.infobtn {
    color: #1d8d56 !important;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 5px;
    text-transform: capitalize !important;
    font-size: 14px !important;
    font-weight: 500;
    padding: 5px !important ;
}
.serarchbtn {
    width: 350px !important;
    height: 44px !important;
    border-radius: 8px;
}
.nodata-msg {
    width: 100%;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
}

// for v menu
.v-menu__content {
    margin-top: 20px;
    width: 250px;
    margin-left: -144px !important;
}
.filterType {
    border-left: 0.6px solid #1d8d56;
    line-height: 10px;
}
.campaignType{
    line-height: 10px;
    
}

.datecon {
    color: #328a37;
    background-color: #328a37;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    padding: 2px 3.5px;
    font-size: 6px;
    margin-right: 5px;
}
</style>

<style>
.campaign-header .v-input__control > .v-input__slot {
    min-height: 44px !important;
}
.campaign-header .v-size--large {
    min-height: 44px !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none;
}

/* search bar  */
.v-size--large {
    min-height: 44px !important;
}
.campaign-header .filterType.v-select > .v-input__control > .v-input__slot {
    cursor: pointer;
    border-radius: 0px 6px 6px 0px !important;
}
.campaign-header .campaignType.v-select > .v-input__control > .v-input__slot {
    cursor: pointer;
    border-radius: 6px 0px 0px 6px !important;
}
.v-messages {
    display: none;
}
.v-list {
    padding: 0px;
}
.v-text-field__details {
    display: none;
}
.search-con .v-input__slot {
    margin-bottom: 0px !important;
    border-radius: 6px 0px 0px 6px;
}
.search-con .v-text-field--filled {
    border-radius: 0px !important;
}
.search-con .v-text-field--outlined fieldset {
    border-color: white !important;
}
.search-con .v-text-field > .v-input__control > .v-input__slot:before {
    border-radius: 100px;
}
.search-con .filterType .v-select__slot {
    border-radius: 40px;
    width: 150px;
}
.search-con .campaignType .v-select__slot {
    border-radius: 40px;
    width: 325px;
}
.sort-items .v-input__slot {
    width: 150px;
}
.search-con .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 44px !important;
}
.search-con .v-list .v-list-item--active {
    color: rgba(0, 0, 0, 0.87) !important;
}
.search-con .v-text-field--filled > .v-input__control > .v-input__slot {
    min-height: 44px !important;
}
.search-con .mdi-menu-down::before {
    margin-bottom: 12px;
}
.search-con .campaignType .mdi-close::before {
    margin-bottom: 12px;
}
.search-con .filterType .mdi-close::before {
    margin-bottom: 12px;
}
</style>
